// extracted by mini-css-extract-plugin
module.exports = {"MasterHeadImg":"styles_MasterHeadImg__iFM8M","container":"styles_container__iNyvU","title":"styles_title__JTL1J","imgFull":"styles_imgFull__h8Gjb"};